import {JobState} from "../types/types";
import {DocType, JobStage} from "../constants/constants";

interface StartProps {
    onSelect: (stage: JobState) => void;
}

export const Start = ({onSelect}: StartProps) => {
    return (
        <div className="container">
            <div className="form-wrapper">
                <h2 style={{textAlign: 'center', marginBottom: 'var(--space-20)'}}>Выберите действие</h2>

                <div style={{display: 'flex', flexDirection: 'column', gap: 'var(--space-12)'}}>
                    <button
                        className="button"
                        onClick={() => onSelect({stage: JobStage.ERID_REPORT})}
                    >
                        Отчитаться по ERID
                    </button>

                    <button
                        className="button"
                        onClick={() => onSelect({stage: JobStage.FORM_DOC_GOOGLE, docContext: DocType.ADDITIONAL})}
                    >
                        Получить ERID
                    </button>

                    <button
                        type="button"
                        className="button button--ghost"
                        onClick={() => window.open('/manager-guide.html', '_blank', 'noopener,noreferrer')}
                    >
                        Инструкция
                    </button>
                </div>
            </div>
        </div>
    );
};
